import { CombinedError, AppError, isNotAuthenticatedError, isOfflineError, isNotFoundError } from '@chronosphereio/core';
import ErrorIcon from 'mdi-material-ui/MagnifyRemoveOutline';
import OfflineIcon from 'mdi-material-ui/WifiOff';
export function getServerErrorMessages(error) {
    if (error instanceof CombinedError && error.graphQLErrors.length > 0) {
        const errorMessages = [];
        for (const graphqlError of error.graphQLErrors){
            errorMessages.push(graphqlError.message);
        }
        return errorMessages;
    } else return undefined;
}
const DEFAULT_SUPPORT_URL = 'https://support.chronosphere.io';
const DEFAULT_SUPPORT_LABEL = 'Contact Chronosphere Support';
/**
 * Derive info used for rendering errors from the given error object
 *
 * @param error - The error to extract details from
 * @param options - Optional error details to override defaults
 * @param config - Optional configuration for support links
 */ export function getErrorDetails(error, options, config) {
    const supportUrl = config?.supportUrl ?? DEFAULT_SUPPORT_URL;
    const supportLabel = config?.supportLabel ?? DEFAULT_SUPPORT_LABEL;
    if (isNotAuthenticatedError(error)) {
        return {
            icon: ErrorIcon,
            severity: 'error',
            title: 'You are no longer logged in',
            message: 'Refresh your browser and contact Chronosphere support if the issue persists',
            link: error instanceof AppError ? undefined : {
                url: supportUrl,
                label: supportLabel
            }
        };
    }
    if (isOfflineError(error)) {
        return {
            icon: OfflineIcon,
            severity: 'error',
            title: "It seems like you're offline",
            message: 'Check your network connection, and then refresh your browser.'
        };
    }
    if (isNotFoundError(error)) {
        return {
            headerText: '404',
            severity: 'error',
            title: error instanceof AppError ? error.title : "We can't find that resource",
            message: error instanceof AppError ? error.message : "The resource might not exist anymore, or there's a typo in the URL. Contact the owner for more information."
        };
    }
    return {
        icon: ErrorIcon,
        severity: options ? options.severity : error instanceof AppError ? error.severity : 'error',
        title: options ? options.title : error instanceof AppError ? error.title : 'Something happened on our end',
        message: options ? options.message : error instanceof AppError ? error.message : 'Refresh your browser and contact Chronosphere support if the issue persists',
        serverMessages: getServerErrorMessages(error),
        link: options || error instanceof AppError ? undefined : {
            url: supportUrl,
            label: supportLabel
        }
    };
}

//# sourceMappingURL=getErrorDetails.js.map